/**
 * Google Customer Reviews — Rating Badge
 */

window.renderBadge = () => {
  const container = document.createElement('div');
  window.gapi.load('ratingbadge', () => {
    window.gapi.ratingbadge.render(container, {
      merchant_id: 3308958,
      position: 'BOTTOM_RIGHT',
    });
    requestAnimationFrame(() => document.body.appendChild(container));
  });
};
